import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, ArrowRight, ShoppingBag } from 'lucide-react';
import { Card } from './ui/card';
import Navbar from './Navbar';
import Footer from './Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const resolveImg = (src) => {
  if (!src) return '';
  if (src.startsWith('http')) return src;
  return `${BACKEND_URL}${src}`;
};

const GuidesList = () => {
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/guides`)
      .then((r) => setGuides(r.data || []))
      .catch(() => setGuides([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-red-50">
      <Navbar />
      <div className="pt-24 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="mb-10">
          <p className="text-red-600 font-semibold text-sm flex items-center gap-2 mb-2">
            <BookOpen size={16} /> GUÍAS Y CONSEJOS
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900">
            Guías de <span className="text-red-600">Drywall</span>
          </h1>
          <p className="text-slate-600 mt-3 max-w-2xl">
            Trucos, técnicas y herramientas recomendadas por profesionales para conseguir
            acabados perfectos en pladur.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-16">
            <div className="animate-spin rounded-full h-10 w-10 border-4 border-red-600 border-t-transparent mx-auto" />
          </div>
        ) : guides.length === 0 ? (
          <p className="text-center text-slate-400 py-16" data-testid="guides-empty">
            Pronto publicaremos nuestras primeras guías. ¡Vuelve pronto!
          </p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="guides-grid">
            {guides.map((g) => (
              <Link key={g.slug} to={`/guias/${g.slug}`} data-testid={`guide-card-${g.slug}`}>
                <Card className="border-0 shadow-md hover:shadow-xl transition-shadow overflow-hidden h-full group">
                  <div
                    className="relative h-44 bg-slate-200 bg-cover bg-center"
                    style={{
                      backgroundImage: g.cover_image
                        ? `url(${resolveImg(g.cover_image)})`
                        : 'none',
                    }}
                  >
                    {g.products && g.products.length > 0 && (
                      <span
                        data-testid={`guide-tools-badge-${g.slug}`}
                        className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-red-600 text-white text-[11px] font-bold px-2.5 py-1 rounded-full shadow-md"
                      >
                        <ShoppingBag size={13} />
                        {g.products.length} herramientas
                      </span>
                    )}
                  </div>
                  <div className="p-5">
                    <span className="text-[11px] uppercase font-bold text-red-600">
                      {g.category || 'General'}
                    </span>
                    <h3 className="font-bold text-slate-900 text-lg leading-tight mt-1 line-clamp-2">
                      {g.title}
                    </h3>
                    <p className="text-sm text-slate-600 mt-2 line-clamp-3">{g.excerpt}</p>
                    {g.products && g.products.length > 0 && (
                      <p className="flex items-center gap-1.5 text-[13px] text-slate-700 font-medium mt-3 bg-slate-50 border border-slate-100 rounded-lg px-2.5 py-1.5">
                        <ShoppingBag size={14} className="text-red-600 shrink-0" />
                        Incluye herramientas recomendadas
                      </p>
                    )}
                    <span className="inline-flex items-center gap-1 text-red-600 text-sm font-semibold mt-3 group-hover:gap-2 transition-all">
                      Ver guía y herramientas <ArrowRight size={14} />
                    </span>
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default GuidesList;
